<template>
  <b-field grouped group-multiline>
    <b-select @input="add" placeholder="Select one" ref="select">
      <option value="" disabled key="empty">Select one</option>
      <option
        v-for="choice in filteredChoices"
        :key="choice.value"
        :value="choice.value">
        {{ choice.label }}
      </option>
    </b-select>
    <div class="control tag-items" v-for="item in items" :key="item.value">
      <b-tag type="is-primary" attached closable @close="remove(item.value)">
        {{ item.label }}
      </b-tag>
    </div>
  </b-field>
</template>

<script>
export default {
  name: 'c-multi-select',
  props: ['value'],
  computed: {
    filteredChoices() {
      return this.value.choices.filter(choice => this.value.data.indexOf(choice.value) === -1)
    },
    items() {
      return this.value.data.map(value => this.value.choices.find(c => c.value === value))
    },
  },
  methods: {
    add(value) {
      if (this.value.data.indexOf(value) !== -1 || this.$refs.select.selected === null) return
      const data = this.value.data.concat(value)
      this.$emit('input', { ...this.value, data })
      this.$refs.select.selected = null
    },
    remove(value) {
      const data = this.value.data.filter(v => v !== value)
      this.$emit('input', { ...this.value, data })
      this.$refs.select.selected = null
    },
  },
}
</script>

<style>
.tag-items {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/lib/components/MultiSelect.vue